import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';

export const useLegacyPageRenderedTrigger = ({ page, showPageAsPopUp }) => {
    useEffect(() => {
        if (page && !showPageAsPopUp) {
            dispatcher.dispatch('page:rendered');
        }
    }, [page, showPageAsPopUp]);
};
